module.exports = __webpack_public_path__ + "static/media/screen2.380fa6bc.png";